/** Wait for durable delivery, including batches restored before this page opened.
 * A healthy queue may take longer than eight seconds; only lack of progress is
 * a timeout. This barrier never removes, rebases or resends a tap itself.
 */
export class TapDeliveryStalledError extends Error {
  constructor() { super("TAP_DELIVERY_STALLED"); this.name = "TapDeliveryStalledError"; }
}

export async function waitForTapDelivery(options: {
  read: () => { count: number; activeRequests: number };
  now: () => number;
  wait: (ms: number) => Promise<void>;
  signal?: AbortSignal;
  onProgress?: (remaining: number) => void;
  stallTimeoutMs?: number;
}): Promise<void> {
  let previous = options.read();
  let lastProgressAt = options.now();
  for (;;) {
    if (options.signal?.aborted) throw new DOMException("Cancelled before spending", "AbortError");
    const current = options.read();
    options.onProgress?.(current.count);
    if (current.count === 0 && current.activeRequests === 0) return;
    if (current.count < previous.count || current.activeRequests < previous.activeRequests) lastProgressAt = options.now();
    if (options.now() - lastProgressAt >= (options.stallTimeoutMs ?? 8_000)) throw new TapDeliveryStalledError();
    previous = current;
    await options.wait(100);
  }
}
